<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="star">
            <defs>
                <path id="hg0y2zrpva" d="M19.937 10.141c-.075-.233-.277-.403-.52-.439l-4.736-.692-2.118-4.29c-.109-.221-.333-.36-.579-.36-.245 0-.47.139-.578.36L9.288 9.01l-4.736.692c-.243.036-.445.206-.52.44-.076.233-.013.49.163.66l3.427 3.338-.81 4.715c-.04.242.059.487.258.631.198.144.462.163.679.05l4.235-2.228 4.236 2.227c.094.05.197.074.3.074.134 0 .267-.041.38-.123.198-.144.297-.389.256-.631l-.809-4.715 3.427-3.338c.176-.17.24-.427.163-.66zm-4.733 3.312c-.152.148-.222.361-.186.57l.645 3.762-3.378-1.777c-.094-.05-.197-.074-.3-.074-.104 0-.207.024-.3.074l-3.38 1.777.645-3.761c.036-.21-.033-.423-.185-.571L6.03 10.79l3.779-.553c.21-.03.391-.162.485-.352l1.69-3.423 1.689 3.423c.094.19.275.322.485.352l3.779.553-2.734 2.663z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="6d05695nub" fill="#fff">
                    <use xlink:href="#hg0y2zrpva"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#6d05695nub)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-star',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>